import { Component, OnInit } from '@angular/core'
import { ProductRecommendationService } from '@mprep/shared/lib/data/services'
import { ProductRecommendation } from '@mprep/shared/data/models'
import { AppContext } from '@mprep/shared'
import { DatePipe, CurrencyPipe } from '@angular/common'

import { NavigationService } from 'app/shared'

@Component({
  selector: 'mp-enrollment',
  templateUrl: './enrollment.html',
  styleUrls: ['./enrollment.scss']
})
export class EnrollmentComponent implements OnInit {

  public recommendations: ProductRecommendation[] = []
  public loading: boolean = true

  public constructor(
    private _productRecommendationService: ProductRecommendationService,
    private _appContext: AppContext,
    private _datePipe: DatePipe,
    private _currencyPipe: CurrencyPipe,
    private _navigationService: NavigationService
  ) {}

  public ngOnInit() {
    this._productRecommendationService
      .findUserUpgrades(this._appContext.currentUser.id)
      .subscribe((recommendations: ProductRecommendation[]) => {
        this.loading = false
        this.recommendations = this._filterAvailableOrFirstUnvailableByTestAndType(recommendations)
      })
  }

  public formatEnrollByDate(recommendation: ProductRecommendation): string {
    const date = recommendation.lastPurchaseDate
    return date && recommendation.available ? this._datePipe.transform(date, 'MM/dd/yyyy') : 'Unavailable'
  }

  public formatPrice(recommendation: ProductRecommendation): string {
    return this._isNumeric(recommendation.price) ? this._currencyPipe.transform(recommendation.price, 'USD', 'symbol', '2.0') : recommendation.price
  }

  public navigateToUpgrade(recommendation: ProductRecommendation): void {
    this._navigationService.navigateToUrl(recommendation.cartUrl)
  }

  private _isNumeric(value: any) {
    return /\d+(\.\d+)?/.test(String(value))
  }

  private _filterAvailableOrFirstUnvailableByTestAndType(recommendations) : ProductRecommendation[] {
    const availableRecsByGrouping = this._groupByTestAndAvailability(recommendations, (r) => r.available)
    const unavailableRecsByGrouping = this._groupByTestAndAvailability(recommendations, (r) => !r.available)

    const recommendationGroupings = Object.keys(availableRecsByGrouping)
    return recommendationGroupings.reduce((filteredRecommendations, testLine) => {
        const availableTestLineRecs = availableRecsByGrouping[testLine]
        const unavailableTestLineRecs = unavailableRecsByGrouping[testLine]

        if (availableTestLineRecs.length > 0) {
          filteredRecommendations.push(...availableTestLineRecs)
        } else if (unavailableTestLineRecs.length > 0) {
          filteredRecommendations.push(unavailableTestLineRecs[unavailableTestLineRecs.length - 1])
        }
        return filteredRecommendations
      }, [] as ProductRecommendation[])
  }

  private _groupByTestAndAvailability(recommendations, filterFn): {[key: string]: ProductRecommendation[]} {
    return recommendations.reduce((recommendationsByTest: {[key: string]: ProductRecommendation[]}, recommendation: ProductRecommendation) => {
      const grouping = this._createGroupingKey(recommendation)
      recommendationsByTest[grouping] = recommendationsByTest[grouping] || []
      if (filterFn(recommendation)) {
        recommendationsByTest[grouping].push(recommendation)
      }
      return recommendationsByTest
    }, {})
  }

  private _createGroupingKey(recommendation) {
    return String(recommendation.testLine).toLowerCase() + '_' + String(recommendation.recommendedItemType).toLowerCase()
  }

}



// WEBPACK FOOTER //
// ./src/app/enrollment/enrollment.component.ts